/**
 * 定数クラス
 */
export class Constants {

    /**
     * API関連
     */
    static readonly API = class {
        /** APIメソッド */
        static readonly METHOD = {
            GET: 'GET',
            POST: 'POST',
        } as const;

        /** APIパス */
        static readonly PATH = {
            /** ログイン */
            LOGIN: '/login',
        } as const;

        /** 認証 */
        static readonly AUTH = {
            /** エラー種別 */
            ERR: {
                /** ログインできていない状態 */
                NO_LOGIN: 'NO_LOGIN',
                /** 無効なトークン */
                INVALID_TOKEN: 'INVALID_TOKEN',
                /** トークンの有効期限切れ */
                TOKEN_EXPIRED: 'TOKEN_EXPIRED'
            } as const,
            /** 状態 */
            STATUS: {
                /** 成功 */
                OK: 'ok',
                /** 失敗 */
                ERR: 'error',
            } as const,

        };
        
        /** パラメータチェック */
        static readonly VALIDATION = {
            /** パスワード入力規則 */
            PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
        } as const;

    };

    /**
     * ユーザー関連
     */
    static readonly USER = class {
        static readonly ROLE_SID = {
            ADMIN: 1,
            INFO: 2,
        } as const;
    }

    /**
     * ソート関連
     */
    static readonly SORT = class {

        /**
         * 画面からのソートキー
         */
        static readonly pageKey = {
            asc: 'ascend',
            desc: 'descend',
        } as const;

    }

}